import intl from "react-intl-universal";
import { LabelButton } from 'components/label-button';
import { FileUpload } from 'components/file-upload';
import { Step2Props } from "../types";

const Step2: React.FC<Step2Props> = ({ errors, contextModal, noMessageExample, downloadModelFile, startFetching, stopFetching, handleReadFile, setCsv, setErrors, setFileName }) => {
  const hanldeDownloadModelFile = () => {
    try {
      startFetching();
      if (downloadModelFile) downloadModelFile();
    } catch (e) {
      console.error('Error occurred while downloading the model file:', e);
    } finally {
      stopFetching();
    }
  };

  return (
    <div className={`content ${errors ? "error-state" : ""}`}>
      <span className={`title ${!downloadModelFile ? "last-title" : ""}`}>
        {intl.get(`exportImportModal.${contextModal}.messageStep2`)}
      </span>
      {downloadModelFile && 
        <LabelButton
          className="title link"
          data-testid="download-model-import"
          onClick={hanldeDownloadModelFile}
        >
          {!noMessageExample &&
            intl.get(`exportImportModal.${contextModal}.downloadModelMessage`)}
        </LabelButton>
      }
      <FileUpload
        handleReadFile={handleReadFile}
        setCsv={setCsv}
        setErrors={setErrors}
        setFileName={setFileName}
      />
      {!!errors.length && (
        <div className="errors-content">
          <p style={{ marginBottom: '8px' }}>{intl.get("master-data.general-configuration.uploadErrors")}</p>
          <ul>
            {errors.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Step2;
